import service from '../../utils/service'
import Urls from '../../utils/urlStrings'
import { MICROSERVICES } from '../../utils/constants'

export class DeveloperHubService {
  async getClientKeys(account_id, account, isSuperAdmin) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/clientKeysForAccount`, MICROSERVICES.PROGRAMMANAGER), { params: isSuperAdmin ? { input_account_id: account } : {} })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  async submitClientForm(values, selectedAccount, clientData, account_id, editData, isSuperAdmin) {
    try {
      const response = await service.post(Urls.getApiUrl(`admin/${account_id}/${editData ? 'updateClientForAccount' : 'generateNewClientForAccount'}`, MICROSERVICES.PROGRAMMANAGER), { clientName: values.clientName, ...(editData ? { clientId: editData.clientId } : {}) }, {
        params: isSuperAdmin ? { input_account_id: selectedAccount.id } : {}
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  async deleteClient(currentUser, selectedAccount, values, isSuperAdmin) {
    try {
      const response = await service.delete(Urls.getApiUrl(`admin/${currentUser.account_id}/deleteClientForAccount/${values.clientId}`, MICROSERVICES.PROGRAMMANAGER), {
        params: isSuperAdmin ? { input_account_id: selectedAccount.id } : {}
      })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  async getClientSecret(account_id, account, clientId, isSuperAdmin) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${account_id}/programs/oauth/secret/${clientId}`, MICROSERVICES.PROGRAMMANAGER), { params: isSuperAdmin ? { input_account_id: account } : {} })
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }
  async getApiMetrics( pageNo, pageSize, startDate, endDate, sortOrder, sortBy, accountName, loginAccountId) {
    const params = { pageNo, pageSize, startDate, endDate, sortOrder, sortBy, accountName }
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${loginAccountId}/insights`, MICROSERVICES.REPORTMANAGER), {params : params})
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async postDownTimeDate(accountId, details) {
    try{
      const response = await service.post(Urls.getApiUrl(`admin/${accountId}/downtime`, MICROSERVICES.REPORTMANAGER), details )
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getApiUrls(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/apiurls`,  MICROSERVICES.REPORTMANAGER))
      const { data } = response
      return data.data
    } catch (e) {
      throw e
    }
  }

  async getStatusPage(accountId) {
    try {
      const response = await service.get(Urls.getApiUrl(`admin/${accountId}/statuspage`,  MICROSERVICES.PROGRAMMANAGER))
      const { data } = response
      return data
    } catch (e) {
      throw e
    }
  }

}

export const developerHubService = new DeveloperHubService()